// src/api/apiService.js

const API_BASE_URL = 'https://elededanza.com/api';

const handleResponse = async (response) => {
  if (!response.ok) {
    let msg = `HTTP ${response.status}`;
    try { const e = await response.json(); msg = e.message || msg; } catch (_) {}
    throw new Error(msg);
  }
  return response.json();
};

// ── Tiendas ────────────────────────────────────────────────────────────────
export const getStores = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_stores.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

// Obtiene la tienda marcada como pública directamente desde la BD.
// Reemplaza el uso de localStorage para publicStoreId.
export const getPublicStore = async () => {
  const stores = await getStores();
  return stores.find(s => s.is_public === true) || null;
};

export const createStore = async (storeData) => {
  const res = await fetch(`${API_BASE_URL}/create_store.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(storeData), credentials: 'include'
  });
  return handleResponse(res);
};

export const updateStore = async (storeData) => {
  const res = await fetch(`${API_BASE_URL}/update_store.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(storeData), credentials: 'include'
  });
  return handleResponse(res);
};

export const deleteStore = async (id) => {
  const res = await fetch(`${API_BASE_URL}/delete_store.php?id=${id}`, { credentials: 'include' });
  return handleResponse(res);
};

// ── Categorías ─────────────────────────────────────────────────────────────
export const getCategories = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_categories.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const createCategory = async (categoryData) => {
  const res = await fetch(`${API_BASE_URL}/create_category.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(categoryData), credentials: 'include'
  });
  return handleResponse(res);
};

export const updateCategory = async (categoryData) => {
  const res = await fetch(`${API_BASE_URL}/update_category.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(categoryData), credentials: 'include'
  });
  return handleResponse(res);
};

export const deleteCategory = async (id) => {
  const res = await fetch(`${API_BASE_URL}/delete_category.php?id=${id}`, { credentials: 'include' });
  return handleResponse(res);
};

// ── Productos ──────────────────────────────────────────────────────────────
export const getProducts = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_products.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const getProductById = async (id) => {
  const res  = await fetch(`${API_BASE_URL}/get_product.php?id=${id}`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const createProduct = async (productData) => {
  const res = await fetch(`${API_BASE_URL}/create_product.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(productData), credentials: 'include'
  });
  return handleResponse(res);
};

export const updateProduct = async (id, productData) => {
  const res = await fetch(`${API_BASE_URL}/update_product.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...productData, id }), credentials: 'include'
  });
  return handleResponse(res);
};

export const deleteProduct = async (id) => {
  const res = await fetch(`${API_BASE_URL}/delete_product.php?id=${id}`, { credentials: 'include' });
  return handleResponse(res);
};

// ── Ventas ─────────────────────────────────────────────────────────────────
export const getSales = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_sales.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const createSale = async (saleData) => {
  const res = await fetch(`${API_BASE_URL}/create_sale.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(saleData), credentials: 'include'
  });
  return handleResponse(res);
};

// ── Inventario ─────────────────────────────────────────────────────────────
export const getInventory = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_inventory.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const updateInventory = async (inventoryData) => {
  const res = await fetch(`${API_BASE_URL}/update_inventory.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(inventoryData), credentials: 'include'
  });
  return handleResponse(res);
};

// ── Reabastecimiento ───────────────────────────────────────────────────────
export const getRestockEntries = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_restock.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const createRestock = async (restockData) => {
  const res = await fetch(`${API_BASE_URL}/create_restock.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(restockData), credentials: 'include'
  });
  return handleResponse(res);
};

// ── Reseñas ────────────────────────────────────────────────────────────────
export const getReviews = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_reviews.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const createReview = async (reviewData) => {
  const res = await fetch(`${API_BASE_URL}/create_review.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(reviewData), credentials: 'include'
  });
  return handleResponse(res);
};

// ── Órdenes ────────────────────────────────────────────────────────────────
export const getOrders = async () => {
  const res  = await fetch(`${API_BASE_URL}/list_orders.php`, { credentials: 'include' });
  const json = await handleResponse(res);
  return json.data;
};

export const createOrder = async (orderData) => {
  const res = await fetch(`${API_BASE_URL}/create_order.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(orderData), credentials: 'include'
  });
  return handleResponse(res);
};

// ── Helpers localStorage (solo para carrito público) ───────────────────────
export const _getFromLocalStorage = (key) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (e) {
    console.error(`Error leyendo localStorage [${key}]:`, e);
    return null;
  }
};

export const _saveToLocalStorage = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify(data));
  } catch (e) {
    console.error(`Error guardando localStorage [${key}]:`, e);
  }
};

// ── Autenticación ──────────────────────────────────────────────────────────
export const loginUser = async (email, password) => {
  const res = await fetch(`${API_BASE_URL}/login.php`, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password }), credentials: 'include'
  });
  return handleResponse(res);
};

export const logoutUser = async () => {
  const res = await fetch(`${API_BASE_URL}/logout.php`, { credentials: 'include' });
  return handleResponse(res);
};
